<template>
  <div class="choose-products" ref="pdfProducts">
    <div class="products-list">
      <div
        class="products"
        v-for="item in productList"
        :key="item.id"
      >
        <img :src="item.image" alt="" class="products-img">
        <div class="products-info">
          <p>{{ item.productName }}</p>
          <div @click.stop="numberChange">
            <el-input-number v-model="item.quantity" :min="0" :precision="0"></el-input-number>
          </div>
        </div>
      </div>
      <div class="products">
        <img src="../../assets/images/new-logo.png" alt="" class="products-img">
        <div class="products-info">
          <p>Additional Product Requirements</p>
          <div @click.stop="numberChange">
            <el-input
              type="textarea" :rows="3" v-model="specialRentalProductRequest"
              placeholder="Enter your additional product requirements"
            ></el-input>
          </div>
        </div>
      </div>
    </div>
    <div class="text_right" style="clear: both">
      <el-button type="primary" @click="onNext" :disabled="productsDisabled">Next</el-button>
    </div>
  </div>
</template>

<script>
import Bus from '../../common/vueBus'
import { getUrlParam } from '@/assets/js/utils'

export default {
  name: 'ChooseProducts',
  data () {
    return {
      productList: [
        {
          productName: 'TVU Pack, 1 Input',
          productId: 0,
          quantity: 0,
          image: require('../../assets/images/TVUPack1.png')
        },
        {
          productName: 'TVU Pack, 4 Inputs',
          productId: 1,
          quantity: 0,
          image: require('../../assets/images/TVUPack2.png')
        },
        {
          productName: 'TVU Receiver, Dual Receiver',
          productId: 2,
          quantity: 0,
          image: require('../../assets/images/DualR.png')
        },
        {
          productName: 'TVU Receiver, Quad Receiver',
          productId: 3,
          quantity: 0,
          image: require('../../assets/images/quaR.png')
        },
        {
          productName: 'TVU Nano Router',
          productId: 4,
          quantity: 0,
          image: require('../../assets/images/Nano.png')
        },
        {
          productName: 'TVU Rack Router',
          productId: 5,
          quantity: 0,
          image: require('../../assets/images/Rack.png')
        },
        {
          productName: 'Mushrooms antennas kit for Nano or Rack router',
          productId: 6,
          quantity: 0,
          image: require('../../assets/images/Mushrooms.png')
        },
        {
          productName: 'Starlink Mini',
          productId: 7,
          quantity: 0,
          image: require('../../assets/images/starLink.png')
        }
      ],
      specialRentalProductRequest: ''
    }
  },
  computed: {
    productsDisabled () {
      return this.productList.every(item => item.quantity === 0) && !this.specialRentalProductRequest
    }
  },
  mounted () {
    let chooseProducts = []
    if (this.$route.path === '/print') {
      chooseProducts = JSON.parse(getUrlParam('chooseProducts'))
    } else {
      chooseProducts = JSON.parse(localStorage.getItem('chooseProducts'))
    }
    if (chooseProducts && chooseProducts.length > 0) {
      chooseProducts.forEach(item => {
        this.productList.forEach(product => {
          if (product.productId === item.productId) {
            product.quantity = item.quantity
          }
        })
      })
    }
    this.specialRentalProductRequest = localStorage.getItem('specialRentalProductRequest') ? localStorage.getItem('specialRentalProductRequest') : ''
  },
  methods: {
    numberChange () {
      this.setProducts()
      Bus.$emit('cartNumChange')
    },
    setProducts () {
      const chooseProducts = this.productList.filter(item => item.quantity > 0)
      localStorage.setItem('chooseProducts', JSON.stringify(chooseProducts))
      localStorage.setItem('specialRentalProductRequest', this.specialRentalProductRequest)
    },
    onNext () {
      this.setProducts()
      this.$emit('productNext')
    }
  }
}
</script>

<style scoped lang="less">
.choose-products {
  //overflow: hidden;
  .products {
    width: 556px;
    float: left;
    display: flex;
    padding: 32px 24px;
    border-radius: 4px;
    border: 1px solid #DBDBDB;
    background: #FAFAFA;
    cursor: pointer;
    margin-bottom: 16px;
  }

  .products-list .products:nth-child(odd) {
    margin-right: 16px;
  }

  .products-img {
    width: 96px;
    margin-left: 24px;
    margin-right: 20px;
  }

  .products-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    p {
      color: #333;
      font-size: 14px;
      font-weight: 500;
    }
  }

  .require-info {
    margin-top: 16px;
    margin-bottom: 36px;
  }

  /deep/ .el-input.is-disabled, .el-input__inner {
    background-color: #FAFAFA;
  }

  /deep/ .el-input .el-input__inner {
    background-color: #FAFAFA;
    border: 1px solid #C6C6C6;
    color: #333333;
  }

  /deep/ .el-input-number {
    .el-input-number__increase, .el-input-number__decrease {
      background-color: #FAFAFA !important;
    }
  }

  /deep/ .el-textarea {
    width: 358px;

    .el-textarea__inner {
      background: #FAFAFA;
      border-color: #DBDBDB;
      font-size: 14px;
    }

    .el-textarea__inner::placeholder {
      color: #DBDBDB;
    }
  }

  .active-border {
    border: 1px solid #69AD48;
  }
}
</style>
